import * as R from "ramda";
const getUrn = (artefact) => R.pipe(
  R.propOr([], "links"),
  R.find(R.propEq("self", "rel")),
  R.when(R.complement(R.isNil), R.prop("urn"))
)(artefact);
export {
  getUrn
};
